import { hue } from './tint';

const SKIN = ['#f5d0b5', '#e8b48e', '#c88d63'];
const NECK = ['#e6bc9e', '#d69f78', '#b07750'];
const HAIR = ['#3a2a21', '#7b4a2b', '#b97c3a'];

/** Hair shapes, drawn over the head (circle at 32,30 r 13). 0 bob, 1 buns, 2 short. */
const HAIR_SHAPES = [
  'M16.5 44V30C16.5 20 23 14.5 32 14.5S47.5 20 47.5 30V44H43V28.5C38 28.5 33.5 26.5 30.5 22.5 28.5 26 25 28.5 21 28.5V44Z',
  'M19 29.5C19 20.5 24.5 15.5 32 15.5S45 20.5 45 29.5C43 25.5 38.5 23 34 23.5 31 24 28 23 26 21.5 24.5 25 22 28 19 29.5Z',
  'M19 28.5C18.5 20 24 15 32 15S45.5 20 45 28.5C43.5 26 41 24.5 38 24.5 33 24.5 28.5 23 26 20.5 24.5 24 22 27 19 28.5Z',
];

/**
 * A flat illustrated face on the member's tint, for people without a photo. `seed` picks the
 * skin, hair color and hair shape (variant 1 is the kid's buns); the shirt follows the name's hue.
 */
export function VectorAvatar({ name, seed = 0 }: { name: string; seed?: number }) {
  const v = Math.abs(seed) % HAIR_SHAPES.length;
  const h = hue(name);
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden>
      <path d="M8 66C9.5 53 19 46.5 32 46.5S54.5 53 56 66Z" fill={`hsl(${h} 58% 60%)`} />
      <path d="M27.5 39H36.5V48C33.5 50 30.5 50 27.5 48Z" fill={NECK[v]} />
      {v === 1 && (
        <>
          <circle cx="19.5" cy="17.5" r="6.2" fill={HAIR[v]} />
          <circle cx="44.5" cy="17.5" r="6.2" fill={HAIR[v]} />
        </>
      )}
      <circle cx="32" cy="30" r="13" fill={SKIN[v]} />
      <path d={HAIR_SHAPES[v]} fill={HAIR[v]} />
      <circle cx="27" cy="31" r="1.7" fill="#2a211b" />
      <circle cx="37" cy="31" r="1.7" fill="#2a211b" />
      <circle cx="24.2" cy="35.2" r="2.5" fill="#f2846f" opacity="0.42" />
      <circle cx="39.8" cy="35.2" r="2.5" fill="#f2846f" opacity="0.42" />
      <path d="M28.6 36Q32 39.2 35.4 36" fill="none" stroke="#2a211b" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
